import Vue from 'vue'
import Vuex from 'vuex'
import {getCookie, setCookie, delCookie} from '../utils/cookie'
// import { getLinkTags } from '../config/api'
Vue.use(Vuex)
const GET_USERINFO = 'GET_USERINFO';
const USER_SINGOUT = 'USER_SINGOUT';
const GET_WINH = 'GET_WINH';
const GET_WINW = 'GET_WINW';
const GET_LINKTAGS = 'GET_LINKTAGS';
const SET_LINKTAGS = 'SET_LINKTAGS';
const USER_SINGIN = 'USER_SINGIN';
const GET_LIKEIDS = 'GET_LIKEIDS';
const SET_LIKEIDS = 'SET_LIKEIDS';
const state = {
    userInfo: null, //用户信息 包括头像和昵称
    isLogin: false, //是否登录
    winH: document.documentElement.clientHeight, //屏幕可用高度
    winW: document.documentElement.clientWidth, //屏幕可用宽度
    links_tags: sessionStorage.getItem("link_tags") ? JSON.parse(sessionStorage.getItem("link_tags")) : ''//底部友情链接和右侧热门标签
}
const getters = {
}
//actions类似于mutation,但它提交的是mutation,不直接变成状态；另外它可以包含任意异步操作
const actions = {
    [GET_WINH](context){
        if (!window.onresize) {
            window.onresize = function(){ // 定义窗口大小变更通知事件
                let winH = document.documentElement.clientHeight;
                let winW = document.documentElement.clientWidth;
                context.commit('GET_WINH', winH);
                context.commit('GET_WINW', winW)
            };
        }
    },
    [GET_LINKTAGS](context){
        if (state.links_tags) {
            return;
        }
        let obj = {};
        // getLinkTags().then(res => {
        //     if (res.code == 200) {
        //         let data = res.data;
        //         context.commit('SET_LINKTAGS', data);
        //         sessionStorage.setItem("link_tags", JSON.stringify(data));
        //     }
        // })
    }
}
//更改store的唯一方法就是提交mutations 每个mutation都有一个字符串的时间类型和一个回调函数
//组件中触发方法 store.commit('getUserInfo')
//为同步事务
const mutations = {
    [GET_USERINFO](state){
        let userInfo = {};
        userInfo.headerImg = getCookie('ark_headimg');
        userInfo.nickName = getCookie('ark_nickname');
        userInfo.userId = getCookie('ark_userid');
        userInfo.token = getCookie('ark_remembertoken');
        state.userInfo = userInfo;
        if (userInfo && userInfo.userId && userInfo.token) {
            state.isLogin = true;
        } else {
            state.isLogin = false;
        }
    },
    [USER_SINGOUT](state){
        delCookie('ark_headimg', '.cheyun.com');
        delCookie('ark_remembertoken', '.cheyun.com');
        delCookie('ark_nickname', '.cheyun.com');
        delCookie('ark_userid', '.cheyun.com');
        delCookie('ark_rememberusername', '.cheyun.com');
        state.isLogin = false;
        state.userInfo = null;
    },
    [USER_SINGIN](state, data){
        setCookie("ark_userid", data.uid, ".cheyun.com", 365*24*60*60)
        setCookie("ark_nickname", data.nick_name, ".cheyun.com", 365*24*60*60)
        setCookie("ark_rememberusername", data.nick_name, ".cheyun.com", 365*24*60*60)
        setCookie("ark_remembertoken", data.login_token, ".cheyun.com", 365*24*60*60)
        setCookie("ark_headimg", data.avatar, ".cheyun.com", 365*24*60*60)
        if (data.uid && data.login_token){
            state.isLogin = true;
        }
        state.userInfo = {
            name: data.nick_name,
            headerImg: data.avatar,
            nickName: data.nick_name,
            userId: data.uid,
            token: data.login_token
        }
    },
    [GET_LIKEIDS](state){
        state.like_ids = JSON.parse(getCookie('like_ids')||'[]');
    },
    [SET_LIKEIDS](state,data){
        setCookie("like_ids", data, ".cheyun.com", 365*24*60*60)
        state.like_ids = JSON.parse(data);
    },

    [USER_SINGOUT](state){
        delCookie('ark_auth', '.cheyun.com');
        delCookie('ark_headimg', '.cheyun.com');
        delCookie('ark_nick_name', '.cheyun.com');
        delCookie('ark_userid', '.cheyun.com');
        state.isLogin = false;
        state.userInfo = null;
    },
    [GET_WINH](state, winH){
        state.winH = winH;
    },
    [GET_WINW](state, winW){
        state.winW = winW;
    },
    [SET_LINKTAGS](state, links_tags){
        state.links_tags = links_tags
    }
}
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js